import { useRouter, withRouter } from "next/router";
import { Offcanvas } from "react-bootstrap";
import { Chat_Uri } from "../../utils/static";

const ChatById = () => {
  const router = useRouter();
  return (
    <Offcanvas
      placement="end"
      show={router.query.chat}
      onHide={(_) => router.back()}
    >
      <Offcanvas.Body className="p-0">
        <iframe
          className="frame-cover"
          src={Chat_Uri + "/" + router.query.chat}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ChatById;
